import { useQuery } from "@apollo/client";

import { SEARCH_AWS_INTEGRATIONS } from "./gql";

const useSearchAwsIntegrations = () => {
  const { loading, error, data } = useQuery(SEARCH_AWS_INTEGRATIONS);

  return {
    integrations: data?.awsIntegrations || [],
    error,
    isPageLoading: loading && !data,
  };
};

export default useSearchAwsIntegrations;
